import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { generateOauthState } from '@/utils/auth';
import TButton from '@/components/atoms/t-button.vue';

interface Props {
  redirectUri: string;
  redirectTo?: string | null;
  page?: string;
  promptSelectAccount?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleButton',
  props: {
    redirectUri: null,
    redirectTo: { default: null },
    page: { default: '/' },
    promptSelectAccount: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { redirectUri: string, redirectTo: string | null, page: string, promptSelectAccount: boolean };

const { $config } = useContext();

/**
 * @property {String} redirectUri - The static url that google will redirect back to. This has to be configured in the facebook developer console.
 * @property {String} redirectTo - When set the page that the user will be redirected to after logging in.
 * @property {String} page - The current page. This is used to redirect back to the users context as we lose that after going through the oauth flow.
 */


const getGoogleCode = (): void => {
  const redirectTo = props.redirectTo ?? (props.page === '/signup/' ? '/hub/' : props.page);
  const url = new URL('https://accounts.google.com/o/oauth2/auth');

  url.searchParams.append('client_id', $config.googleClientId);
  url.searchParams.append('response_type', 'code');
  url.searchParams.append('redirect_uri', `${$config.baseURL}${props.redirectUri}`);
  url.searchParams.append('state', generateOauthState('google', redirectTo));
  url.searchParams.append('scope', 'email profile');
  if (props.promptSelectAccount) {
    url.searchParams.append('prompt', 'select_account');
  }

  window.location.href = url.toString();
};

return { __sfc: true,$config, props, getGoogleCode, TButton }
}

})